import React, { Component } from "react";
import {
  db,
  fbLogout,
  fetchActiveProduct,
  listenEmailVerificationStatus,
  listenUserAuthState,
  pullUserDataWithRetry,
} from "./db/firebaseMethods";
import { doc, onSnapshot } from "firebase/firestore";
import { getAuth, signOut } from "firebase/auth";

// import {  listenAuthenticatedUserChanges, pullUsers, pullReportsOfWriter, pullAllReports } from "./firestoreMethods";
// import {
//   pullQuestions,
//   pullAnswers,
//   listenAuthenticatedUserChanges,
// } from "./db/FirebaseMethods";
// import { getServerDate } from "./db/FirebaseMethods";
// import { convertStringToDate, convertDateToString } from "./HelperFunctions";

const AppContext = React.createContext();

class AppProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      activeProduct: null,
      isLoggedInByOriginalPass: false,
      userDataLoadError: null,
    };
  }

  componentDidMount() {
    listenUserAuthState(this.userSetter);
    fetchActiveProduct().then((res) => this.setState({ activeProduct: res }));
  }

  componentDidUpdate(prevProps, prevState) {
    let unsub;
    if (
      this.state.user !== prevState.user &&
      this.state.user !== null &&
      this.state.isLoggedInByOriginalPass
    ) {
      unsub = onSnapshot(doc(db, "users", this.state.user?.uid), (doc) => {
        if (
          this.state.user?.stsTokenManager?.refreshToken.slice(-10) !==
            doc.data()?.token_for_concurrent_logins &&
          doc.data()?.token_for_concurrent_logins !== 0
        ) {
          const auth = getAuth();
          signOut(auth);
        }
      });
    }
    if (!this.state.user && typeof unsub === "function") {
      unsub();
    }
  }

  userSetter = async (u) => {
    const prevUid = this.state.user?.uid;
    const newUid = u?.uid;

    if (u === null) {
      this.setState({ user: null, userDataLoadError: null });
      return;
    }

    if (prevUid === newUid) {
      // Aynı kullanıcı için tekrar çağrıldı: daha önce çekilen profil
      // verisini kaybetmemek için mevcut state ile birleştir.
      this.setState({ user: { ...this.state.user, ...u } });
      return;
    }

    const { data, error } = await pullUserDataWithRetry(u.uid);
    this.setState({
      user: { ...u, ...data },
      userDataLoadError: error || null,
    });
  };
  isLoggedInByOriginalPassFunc = (bool) => {
    this.setState({ isLoggedInByOriginalPass: bool });
  };

  refreshUserData = async () => {
    const userId = this.state.user?.uid;
    if (userId) {
      const { data, error } = await pullUserDataWithRetry(userId);
      if (error) {
        this.setState({ userDataLoadError: error });
        return;
      }
      const newUser = { ...this.state.user, ...data };
      this.setState({ user: newUser, userDataLoadError: null });
    }
  };

  setCentralState = (obj) => {
    this.setState(obj);
  };

  render() {
    const {
      setCentralState,
      refreshUserData,
      userSetter,
      isLoggedInByOriginalPassFunc,
    } = this;

    return (
      <AppContext.Provider
        value={{
          ...this.state,
          setCentralState,
          refreshUserData,
          userSetter,
          isLoggedInByOriginalPassFunc,
        }}
      >
        {this.props.children}
      </AppContext.Provider>
    );
  }
}

export default AppContext;

export { AppProvider };
